export default __webpack_public_path__ + "static/media/product-09.210911fa.jpg";